<template>
  <div v-if="input">
    <v-layout wrap align-center>
      <v-flex xs12>
        <v-layout row align-center>
          <v-flex shrink class="text-xs-left px-2"> {{ min }} sec </v-flex>
          <v-flex>
            <v-slider
              v-model="input.close_by_bot_duration_time"
              name="close_by_bot_duration_time"
              class="default-input"
              :min="min"
              :max="max"
              :step="step"
              thumb-label
            ></v-slider>
          </v-flex>
          <v-flex shrink class="text-xs-right px-2"> {{ max }} sec </v-flex>
        </v-layout>
      </v-flex>
      <v-flex xs12 class="text-xs-center my-4">
        <v-btn color="grey" outline :loading="loading" @click="onCancel">{{ $t('cancel') }}</v-btn>
        <v-btn color="primary" depressed :loading="loading" @click="onSave">{{ $t('Save') }}</v-btn>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import cloneDeep from 'lodash/cloneDeep'
import ticket3PageApi from '@/api/ticket3/page.js'
import { handleApiError } from '@/api/util'
import { mapGetters } from 'vuex'
export default {
  props: ['setting'],
  data() {
    return {
      input: undefined,
      loading: false,
      min: 60,
      max: 3600,
      step: 10
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    })
  },
  mounted() {
    this.input = cloneDeep(this.setting)
  },
  methods: {
    async handleSubmit() {
      const result = await this.$validator.validateAll()
      if (result) {
        this.loading = true
        try {
          await ticket3PageApi.putCloseByBotTime({
            data: { page_id: this.selectedBot.pageid, ...this.input }
          })
          this.$emit('updateSetting', this.input)
          this.$emit('onClose')
        } catch (error) {
          handleApiError(error)
        } finally {
          this.loading = false
        }
      }
    },
    onCancel() {
      this.$emit('onClose')
    },
    onSave() {
      this.handleSubmit()
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/ticket3/ticket-management/Setting/CloseByBotManagement.vue